var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { name: "query-sort-block" } },
        [
          _c("swb-query-sort-area", {
            ref: "query_model_ctrl",
            attrs: {
              confKey: _vm.confKey,
              configAuto: true,
              queryOnLoad: true,
              queryHandler: _vm.queryHandler
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "simple-row clearfix", attrs: { name: "btn-block" } },
        [
          _c("div", { staticClass: "left" }, [
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.addPart(null)
                  }
                }
              },
              [_vm._v("新增部件")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.addPartFromAsmbl(null)
                  }
                }
              },
              [_vm._v("从组装件选择")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.repairFlag
        ? _c(
            "div",
            { staticClass: "hint block", attrs: { name: "hint-msg" } },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("swb-result-table", {
        ref: "result_table",
        attrs: {
          name: "result_table",
          btnColBaseCount: 2,
          btnColMoreTitle: "更多操作",
          confKey: _vm.confKey,
          configAuto: true,
          needPager: _vm.needPager,
          multiSelect: _vm.multiSelect,
          multiPageSelect: _vm.multiPageSelect,
          rowKeyPropName: _vm.rowKeyPropName,
          rowNoShow: _vm.rowNoShow,
          rowNoFixed: _vm.rowNoFixed,
          btnColName: _vm.btnColName,
          btnColTitle: _vm.btnColTitle,
          btnColWidth: _vm.btnColWidth,
          btnColFixed: _vm.btnColFixed,
          height: _vm.theTableHeight,
          pageNoChangeHandler: _vm.pageNoChangeHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "font-red" }, [
        _vm._v("提示：仅需维修设备才可设置可维修操作")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7325f87c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7325f87c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devc/DevcRelatedPartList.vue
// module id = 2499
// module chunks = 0